function sanitizeFilenamePart(value) {
  return String(value)
    .trim()
    .replace(/[^\w.-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function buildCashflowDownloadFilename({
  customerName,
  scenarioLabel,
  baseName,
}) {
  const safeBase = sanitizeFilenamePart(baseName) || 'cashflow-model';
  if (!scenarioLabel?.trim()) {
    return `${safeBase}.csv`;
  }

  const parts = [customerName, scenarioLabel]
    .filter(Boolean)
    .map(sanitizeFilenamePart)
    .filter(Boolean);

  if (parts.length === 0) {
    return `${safeBase}.csv`;
  }

  return `${parts.join('-')}-${safeBase}.csv`;
}
